import React, {FC, memo} from 'react';

import {
  isDesktopAppVersionGTE,
  isElectron,
} from '../../../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {getHasOldDesktopVersionBanner} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerAction} from '../../../../../libs/shared/ui/src/components/banners/bannerAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../../../libs/shared/ui/src/components/banners/bannerFooterActions';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';

/*
 * Component.
 */

export const OldDesktopVersionBannerComponent: FC = () => {
  const theme = useUserTheme();
  const hasBanner = useAppSelector(getHasOldDesktopVersionBanner);

  if (!hasBanner || !isElectron() || isDesktopAppVersionGTE('3.28.3')) {
    return null;
  }

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.orange.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerIcon iconName="warningFilledSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-old-desktop-version-title">Your app is out of date</Trans>
        </BannerContentTitle>
        <Trans id="banner-old-desktop-version-content">
          Download and install the latest version to continue using Front.
        </Trans>
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={() => openInBrowser('https://frontapp.com/download')}>
          <Trans id="banner-old-desktop-version-download">Download</Trans>
        </BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};

export const OldDesktopVersionBanner = memo(OldDesktopVersionBannerComponent);
